import { findIndex } from 'lodash';

import * as constants from './Coupon.constants';
import * as services from './Coupon.service';

const state = {
  MyCoupons: [],
};

const mutations = {
  [constants.GET_MY_COUPONS_SUCCESS](state, data) {
    state.MyCoupons = data.MyCoupons;
  },
};

const actions = {
  async getMyCoupons({ commit }, payload) {
    try {
      const res = await services.getMyCoupons(payload);
      if (res.data.data) {
        commit(constants.GET_MY_COUPONS_SUCCESS, { MyCoupons: res.data.data });
      }
    } catch (e) {
      commit(constants.GET_MY_COUPONS_SUCCESS, {
        MyCoupons: [],
      });
    }
  },
};

const getters = {
  MyCoupons: state =>
    Array.isArray(state.MyCoupons) &&
    state.MyCoupons.length > 0 &&
    state.MyCoupons.sort((v1, v2) => parseInt(v1.status) - parseInt(v2.status)).map(v => ({
      ...v,
      title: `<p>购买课程: ${v.goodsDetailName}</p>
    <p>抵扣金额: ${v.couponValue}</p>
    <p>购买日期: ${v.payDateString}</p>`,
    })),
  Used: state =>
    (Array.isArray(state.MyCoupons) &&
      state.MyCoupons.length > 0 &&
      state.MyCoupons.filter(v => v.status == 2).length) ||
    0,
  UnUsed: state =>
    (Array.isArray(state.MyCoupons) &&
      state.MyCoupons.length > 0 &&
      state.MyCoupons.filter(v => v.status == 1).length) ||
    0,
  Expired: state =>
    (Array.isArray(state.MyCoupons) &&
      state.MyCoupons.length > 0 &&
      state.MyCoupons.filter(v => v.status == 3).length) ||
    0,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
